(() => {
  const menuButton = document.querySelector('.menu-button');
  const menu = document.getElementById('mobile-menu');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') !== 'true';
      menuButton.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
    });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
      menu.hidden = true;
      menuButton.setAttribute('aria-expanded', 'false');
    }));
  }
  const bag = document.querySelector('.bag-dialog');
  document.querySelectorAll('[data-open-bag]').forEach(button => button.addEventListener('click', () => bag?.showModal()));
  document.querySelector('[data-close-bag]')?.addEventListener('click', () => bag?.close());
  document.querySelector('[data-bag-browse]')?.addEventListener('click', () => {
    bag?.close();
    const target = document.getElementById('first-find');
    if (target) target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    else window.location.href = '/#first-find';
  });
  bag?.addEventListener('click', event => { if (event.target === bag && event.clientX < bag.getBoundingClientRect().left) bag.close(); });
  bag?.addEventListener('close', () => document.body.style.removeProperty('overflow'));
  document.querySelectorAll('[data-open-bag]').forEach(button => button.addEventListener('click', () => document.body.style.overflow = 'hidden'));
  document.querySelectorAll('[data-year]').forEach(element => element.textContent = new Date().getFullYear());
})();

// Individual product pages: progressively enhanced; the Shopify form stays native.
(() => {
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  function updateGallery(gallery, thumb, imageUrl) {
    const main = gallery?.querySelector('img.gallery-main-image');
    const source = imageUrl || thumb?.dataset.image;
    if (!main || !source) return;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = source;
    if (thumb) main.alt = thumb.dataset.alt || '';
    if (!reduced() && main.animate) main.animate([{ opacity: 0.45 }, { opacity: 1 }], { duration: 240, easing: 'ease-out' });
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (thumb) {
      thumbs.forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
      const counter = gallery.querySelector('[data-gallery-counter]');
      if (counter) counter.textContent = `${thumbs.indexOf(thumb) + 1} / ${thumbs.length}`;
      const rail = thumb.parentElement;
      rail.scrollTo({ left: Math.max(0, thumb.offsetLeft - rail.clientWidth / 2 + thumb.clientWidth / 2), behavior: reduced() ? 'instant' : 'smooth' });
    }
  }
  function updateQuantity(input) {
    const group = input.closest('.quantity-stepper');
    if (!group) return;
    const value = Number(input.value);
    group.querySelector('[data-quantity-change="-1"]').disabled = !input.value || value <= Number(input.min || 1);
    group.querySelector('[data-quantity-change="1"]').disabled = !!input.max && value >= Number(input.max);
  }
  function initialize(scope = document) {
    scope.querySelectorAll('[data-product-page]').forEach(page => {
      if (page.dataset.productReady) return;
      page.dataset.productReady = 'true';
      page.querySelectorAll('[data-quantity-change]').forEach(button => { button.hidden = false; });
      page.querySelectorAll('.product-quantity').forEach(updateQuantity);
      const gallery = page.querySelector('[data-product-gallery]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      const navigation = gallery.querySelector('[data-gallery-navigation]');
      if (navigation && thumbs.length > 1) {
        navigation.hidden = false;
        navigation.querySelector('[data-gallery-counter]').textContent = `${Math.max(0, thumbs.findIndex(thumb => thumb.getAttribute('aria-pressed') === 'true')) + 1} / ${thumbs.length}`;
      }
      const dialog = gallery.querySelector('[data-product-zoom]');
      if (dialog && typeof dialog.showModal === 'function') {
        gallery.querySelector('[data-open-product-zoom]').hidden = false;
        dialog.addEventListener('close', () => { document.body.style.overflow = dialog.dataset.previousOverflow || ''; });
        dialog.addEventListener('click', event => {
          if (event.target === dialog) {
            const box = dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
          }
        });
      }
      page.querySelectorAll('[data-product-description] img').forEach(img => { img.loading = 'lazy'; img.decoding = 'async'; });
    });
  }
  document.addEventListener('click', event => {
    const page = event.target.closest('[data-product-page]');
    if (!page) return;
    const gallery = page.querySelector('[data-product-gallery]');
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (thumb) updateGallery(gallery, thumb);
    const direction = event.target.closest('[data-gallery-direction]');
    if (direction) {
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      const selected = Math.max(0, thumbs.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
      updateGallery(gallery, thumbs[(selected + Number(direction.dataset.galleryDirection) + thumbs.length) % thumbs.length]);
    }
    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const input = quantityButton.closest('.quantity-stepper').querySelector('input');
      if (!input.value || !input.validity.valid) input.value = input.min || '1';
      else if (Number(quantityButton.dataset.quantityChange) > 0) input.stepUp();
      else input.stepDown();
      updateQuantity(input);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (event.target.closest('[data-open-product-zoom]')) {
      const dialog = gallery.querySelector('[data-product-zoom]');
      const image = dialog.querySelector('img');
      const main = gallery.querySelector('img.gallery-main-image');
      image.removeAttribute('srcset');
      image.src = main.currentSrc || main.src;
      image.alt = main.alt;
      dialog.dataset.previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    }
    if (event.target.closest('[data-close-product-zoom]')) gallery.querySelector('[data-product-zoom]').close();
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-variant-select]');
    if (select) {
      const option = select.selectedOptions[0];
      const price = document.getElementById(select.dataset.priceTarget);
      const button = document.getElementById(select.dataset.buttonTarget);
      if (price) price.textContent = option.dataset.price;
      if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'Sold out' : 'Add to bag'; }
      const page = select.closest('[data-product-page]');
      const stock = page?.querySelector('[data-product-stock]');
      if (stock) { stock.toggleAttribute('data-sold-out', option.dataset.available !== 'true'); stock.querySelector('[data-stock-text]').textContent = option.dataset.available === 'true' ? 'Available' : 'Sold out'; }
      if (page && option.dataset.image) {
        const gallery = page.querySelector('[data-product-gallery]');
        const thumb = Array.from(gallery.querySelectorAll('[data-gallery-thumb]')).find(item => item.dataset.imageId === option.dataset.imageId);
        updateGallery(gallery, thumb, option.dataset.image);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState(history.state, '', url);
    }
    if (event.target.matches('.product-quantity')) updateQuantity(event.target);
  });
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

// Finite, progressive-enhancement motion: content stays readable without JS.
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  const seen = new WeakSet();
  const selector = '.hero-copy > *, .hero-figure, .section-heading, .shop-card, .story-copy, .faq-intro, .faq-list details, .footer-main > *, .catalog-heading, .product-gallery, .product-purchase, .product-details-panel';
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (!reducedMotion.matches) entry.target.classList.add('orlivana-arrive');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08 });
  function prepareMotion(root = document) {
    if (reducedMotion.matches) return;
    root.querySelectorAll(selector).forEach(element => {
      if (seen.has(element) || element.closest('[data-product-carousel]')) return;
      seen.add(element);
      if (element.matches('.shop-card, .hero-copy > *, .footer-main > *')) {
        const position = Array.from(element.parentElement.children).indexOf(element);
        element.style.setProperty('--arrival-delay', `${Math.min(position, 3) * 65}ms`);
      }
      observer.observe(element);
    });
  }
  prepareMotion();
  document.addEventListener('shopify:section:load', event => prepareMotion(event.target));
  reducedMotion.addEventListener('change', event => {
    if (event.matches) observer.disconnect();
    else prepareMotion();
  });
})();

// A single-row, circular product shelf. Original cards remain the source of truth.
(() => {
  const instances = new Map();
  function createCarousel(root) {
    const viewport = root.querySelector('[data-carousel-viewport]');
    const track = root.querySelector('[data-carousel-track]');
    const originals = Array.from(track.querySelectorAll('.carousel-slide'));
    const count = originals.length;
    root.dataset.carouselCount = count;
    root.dataset.carouselVersion = 'continuous-2026-10-01-click-fix';
    if (!count) return () => {};
    const controls = root.querySelector('[data-carousel-controls]');
    const toggle = root.querySelector('[data-carousel-toggle]');
    const counter = root.querySelector('[data-carousel-counter]');
    const announcement = root.querySelector('[data-carousel-announcement]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    const listen = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: events.signal });
    const interval = Math.max(4, Number(root.dataset.interval) || 5) * 1000;
    let paused = root.dataset.autoplay === 'false' || motion.matches;
    let focusPaused = false;
    let timer;
    let releaseTimer;
    let running;
    let pointer;
    let blockClickUntil = 0;
    let destroyed = false;
    const slides = () => Array.from(track.children).filter(slide => !slide.hasAttribute('data-carousel-clone'));
    const columns = () => Math.min(count, Math.max(1, parseInt(getComputedStyle(root).getPropertyValue('--carousel-columns'), 10) || 1));

    function update() {
      const ordered = slides();
      const visibleCount = columns();
      ordered.forEach((slide, index) => {
        // The incoming card is already visible while the row is gliding.
        const interactive = index < visibleCount || slide === running?.entering || slide === running?.exiting;
        slide.inert = !interactive;
        slide.setAttribute('aria-hidden', String(!interactive));
        // Preload only the visible cards and the next one, not the whole catalog.
        if (index <= visibleCount) slide.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
      });
      const position = ordered[0].dataset.productIndex;
      root.dataset.carouselPosition = position;
      counter.textContent = `${position} / ${count}`;
      const stopped = paused || focusPaused || motion.matches;
      root.dataset.carouselPaused = String(stopped);
      toggle.setAttribute('aria-label', stopped ? 'Resume automatic product rotation' : 'Pause automatic product rotation');
      toggle.querySelector('[data-carousel-toggle-text]').textContent = stopped ? 'Play' : 'Pause';
      toggle.querySelector('[data-carousel-toggle-icon]').textContent = stopped ? '▷' : 'Ⅱ';
      toggle.hidden = motion.matches;
      root.classList.toggle('carousel-reduced-motion', motion.matches);
    }
    function schedule() {
      clearTimeout(timer);
      if (!destroyed && count > 1 && !paused && !focusPaused && !motion.matches && !document.hidden && !running && !pointer) {
        // Start immediately, then glide directly into the next card with no dwell.
        timer = setTimeout(() => move(1, false), 0);
      }
    }
    function syncPlayback() {
      if (destroyed) return;
      const stopped = paused || focusPaused || motion.matches || document.hidden || !!pointer;
      if (running) running.animations.forEach(animation => stopped ? animation.pause() : animation.play());
      update();
      schedule();
    }
    function cancelMove() {
      if (!running) return;
      const active = document.activeElement;
      const transition = running;
      running = null;
      transition.animations.forEach(animation => animation.cancel());
      transition.clone.remove();
      transition.before.forEach(slide => track.append(slide));
      root.classList.remove('carousel-moving');
      update();
      if (active && track.contains(active)) active.focus({ preventScroll: true });
    }
    function move(direction, manual = true) {
      if (count < 2 || destroyed) return;
      if (running) {
        if (!manual) return;
        cancelMove();
      }
      clearTimeout(timer);
      const before = slides();
      const visibleCount = columns();
      const complete = () => {
        update();
        if (manual) announcement.textContent = `Product ${slides()[0].dataset.productIndex} of ${count}: ${slides()[0].querySelector('h3').textContent.trim()}`;
        schedule();
      };
      if (motion.matches || !track.animate) {
        if (direction > 0) track.append(before[0]);
        else track.prepend(before[count - 1]);
        complete();
        return;
      }
      const step = before[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      const wrapping = direction > 0 ? before[0] : before[count - 1];
      const clone = wrapping.cloneNode(true);
      clone.setAttribute('data-carousel-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      // A wrapping copy can be visible in a small catalog. Keep its native
      // links clickable, but do not duplicate it in the keyboard tab order.
      clone.inert = false;
      clone.querySelectorAll('a, button, [tabindex]').forEach(element => { element.tabIndex = -1; });
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
      track.append(clone);
      if (direction < 0) track.prepend(wrapping);
      const entering = direction > 0 ? track.children[visibleCount] : wrapping;
      const exiting = direction > 0 ? before[0] : track.children[visibleCount];
      entering.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
      const options = { duration: manual ? 600 : interval, easing: manual ? 'cubic-bezier(.22,.61,.36,1)' : 'linear', fill: 'both' };
      root.classList.add('carousel-moving');
      const animations = [
        track.animate([{ transform: `translateX(${direction > 0 ? 0 : -step}px)` }, { transform: `translateX(${direction > 0 ? -step : 0}px)` }], options),
        exiting.animate([{ opacity: 1, offset: 0 }, { opacity: 1, offset: 0.5 }, { opacity: 0, offset: 1 }], options),
        entering.animate([{ opacity: 0, offset: 0 }, { opacity: 1, offset: 0.5 }, { opacity: 1, offset: 1 }], options)
      ];
      const transition = { animations, clone, before, entering, exiting };
      running = transition;
      animations[0].finished.then(() => {
        if (running !== transition || destroyed) return;
        if (direction > 0) track.append(wrapping);
        clone.remove();
        animations.forEach(animation => animation.cancel());
        running = null;
        root.classList.remove('carousel-moving');
        complete();
      }).catch(() => {});
      update();
    }

    root.classList.add('carousel-ready');
    controls.hidden = count < 2;
    update();
    listen(root.querySelector('[data-carousel-previous]'), 'click', () => move(-1));
    listen(root.querySelector('[data-carousel-next]'), 'click', () => move(1));
    listen(toggle, 'click', () => {
      paused = !(paused || focusPaused);
      focusPaused = false;
      syncPlayback();
    });
    listen(root, 'focusin', event => {
      if (toggle.contains(event.target)) return;
      // Arrow controls stay stationary, so focusing them need not stop the row.
      // Product links pause the row so a focused item never moves out of reach.
      if (track.contains(event.target)) {
        focusPaused = true;
        syncPlayback();
      }
    });
    listen(root, 'focusout', event => {
      if (track.contains(event.relatedTarget)) return;
      focusPaused = false;
      syncPlayback();
    });
    listen(root, 'keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      // Keep keyboard focus on the controls, never hide a focused product link.
      if (track.contains(event.target)) return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    });
    listen(viewport, 'pointerdown', event => {
      if (!event.isPrimary || event.button > 1) return;
      // Freeze exactly where the customer pressed. Resetting/reordering here
      // moves the link away before pointerup and prevents the native click.
      pointer = { x: event.clientX, y: event.clientY, id: event.pointerId };
      clearTimeout(releaseTimer);
      clearTimeout(timer);
      if (running) running.animations.forEach(animation => animation.pause());
    });
    listen(window, 'pointerup', event => {
      if (!pointer || event.pointerId !== pointer.id) return;
      const dx = event.clientX - pointer.x;
      const dy = event.clientY - pointer.y;
      pointer = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        blockClickUntil = Date.now() + 500;
        move(dx < 0 ? 1 : -1);
      } else {
        // Let the browser finish dispatching the click before motion resumes.
        releaseTimer = setTimeout(syncPlayback, 0);
      }
    });
    listen(window, 'pointercancel', () => { pointer = null; syncPlayback(); });
    listen(viewport, 'click', event => {
      if (Date.now() < blockClickUntil) { event.preventDefault(); event.stopPropagation(); }
    }, { capture: true });
    listen(document, 'visibilitychange', syncPlayback);
    listen(window, 'resize', () => {
      cancelMove();
      const ordered = slides();
      const focused = ordered.find(slide => slide.contains(document.activeElement));
      if (focused && ordered.indexOf(focused) >= columns()) {
        while (slides()[0] !== focused) track.append(slides()[0]);
      }
      update();
      schedule();
    });
    listen(motion, 'change', () => { paused = true; cancelMove(); update(); schedule(); });
    // No intersection threshold: Shopify's embedded preview must start as well.
    schedule();
    return () => {
      destroyed = true;
      clearTimeout(timer);
      clearTimeout(releaseTimer);
      events.abort();
      cancelMove();
      originals.forEach(slide => { track.append(slide); slide.inert = false; slide.removeAttribute('aria-hidden'); });
      root.classList.remove('carousel-ready');
      controls.hidden = true;
    };
  }
  function initialize(scope = document) {
    scope.querySelectorAll('[data-product-carousel]').forEach(root => {
      if (!instances.has(root)) instances.set(root, createCarousel(root));
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, root) => {
      if (event.target.contains(root)) { destroy(); instances.delete(root); }
    });
  });
})();
